module.exports = __webpack_public_path__ + "static/media/two-people-heart-2.27a3ca39.svg";